import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ComparisonArticlePage from "../pages/comparison/page";
import SetupGuideArticlePage from "../pages/setup-guide/page";
import AdvancedTipsArticlePage from "../pages/advanced-tips/page";
import ShoppingGuidePage from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuidePage />,
  },
  {
    path: "/what-is-mulebuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/mulebuy-spreadsheet-comparison",
    element: <ComparisonArticlePage />,
  },
  {
    path: "/mulebuy-spreadsheet-setup-guide",
    element: <SetupGuideArticlePage />,
  },
  {
    path: "/mulebuy-spreadsheet-advanced-tips",
    element: <AdvancedTipsArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;